// extracted by mini-css-extract-plugin
export default {"title":"ContentWrapper_title__c5yV3","wrapper":"ContentWrapper_wrapper__bRycp"};